class SsoJwtMockerService {
    static { this.JWT_HEADER = {
        alg: 'ES512',
        typ: 'JWT',
    }; }
    static { this.JWT_SIG = {
        sig: 'invalid',
    }; }
    static { this.regexTrailingEquals = new RegExp('=+$'); }
    static { this.regexPlus = new RegExp('\\+', 'g'); }
    static { this.regexSlash = new RegExp('\\/', 'g'); }
    static createTokenWithJunkSignature(body) {
        return [
            SsoJwtMockerService.b64encodeObject(SsoJwtMockerService.JWT_HEADER),
            SsoJwtMockerService.b64encodeObject(body),
            SsoJwtMockerService.b64encodeObject(SsoJwtMockerService.JWT_SIG),
        ].join('.');
    }
    static dateClaimCurrent() {
        return SsoJwtMockerService.calcJwtDateClaim(new Date(), 0);
    }
    static dateClaimCurrentWithOffset(offset) {
        return SsoJwtMockerService.calcJwtDateClaim(new Date(), offset);
    }
    static dateClaimWithDate(date) {
        return SsoJwtMockerService.calcJwtDateClaim(date, 0);
    }
    static calcJwtDateClaim(date, offset) {
        return Math.floor((date.getTime() + offset) / 1000);
    }
    static b64encodeObject(obj) {
        return encodeURIComponent(btoa(JSON.stringify(obj)).replace(SsoJwtMockerService.regexTrailingEquals, ''))
            .replace(SsoJwtMockerService.regexPlus, '-')
            .replace(SsoJwtMockerService.regexSlash, '_');
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { SsoJwtMockerService };
